import React, { useState, useEffect } from "react";
import { Configurations } from "../../../../Utils/Configurations";
import axios from "axios";
import { withRouter } from 'react-router-dom';
import PodcastPlaylistCard from "../../../../Components/Playlist/Podcast/PodcastPlaylistCard.js";

const PodcastPlaylistList = ({ history }) => {

    const [playlists, setPlaylists] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        chamadaPlaylists()
    }, [])

    const chamadaPlaylists = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/playlist/podcast?page=1&pageSize=10`)
            .then(response => {
                setPlaylists(response.data.data)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)

            });
    }

    useEffect(() => {
        if (playlists) {
            setLoading(false);
        }
    }, [playlists])

    const moveUp = (index) => {
        if (index === 0) return; // Não move se for o primeiro item
        const newPlaylists = [...playlists];
        [newPlaylists[index], newPlaylists[index - 1]] =
            [newPlaylists[index - 1], newPlaylists[index]];
        setPlaylists(newPlaylists);
    }

    const moveDown = (index) => {
        if (index === playlists.length - 1) return; // Não move se for o último item
        const newPlaylists = [...playlists];
        [newPlaylists[index], newPlaylists[index + 1]] =
            [newPlaylists[index + 1], newPlaylists[index]];
        setPlaylists(newPlaylists);
    }

    const novaPlaylist = () => {
        history.push({
            pathname: `detalhes/novo`,
        });
    }

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Podcasts - Playlists</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary cursor-pointer" type="button" onClick={() => novaPlaylist()}>
                                nova playlist
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters align-items-center py-lg-4 px-lg-3">
                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <div className="col-lg-10 col-12 offset-lg-1 offset-0">
                            {playlists && playlists.map((item, indice) => {
                                return (
                                    <PodcastPlaylistCard
                                        conteudo={item}
                                        setLoading={setLoading}
                                        key={item._id}
                                        indice={indice}
                                        size={playlists.length}
                                        chamadaPlaylists={chamadaPlaylists}
                                        onMoveUp={moveUp}
                                        onMoveDown={moveDown}
                                    />
                                )
                            })}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default withRouter(PodcastPlaylistList);